const CloseIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2076 3.07792C16.3392 2.94676 16.4437 2.79088 16.515 2.61926C16.5862 2.44763 16.6229 2.26363 16.6229 2.0778C16.6229 1.89197 16.5862 1.70797 16.515 1.53634C16.4437 1.36472 16.3392 1.20885 16.2076 1.07768C16.1023 0.990844 15.97 0.943359 15.8335 0.943359C15.6969 0.943359 15.5646 0.990844 15.4592 1.07768L8.97021 7.57025L3.10477 1.70599C2.97361 1.57436 2.81773 1.46992 2.64612 1.39865C2.47449 1.32739 2.29049 1.29071 2.10466 1.29071C1.91883 1.29071 1.73482 1.32739 1.5632 1.39865C1.39157 1.46992 1.23571 1.57436 1.10453 1.70599C1.0177 1.81135 0.970215 1.94363 0.970215 2.08015C0.970215 2.21669 1.0177 2.34896 1.10453 2.45431L7.59711 8.94336L1.73285 14.8088C1.60122 14.9399 1.49677 15.0959 1.42551 15.2674C1.35425 15.4391 1.31756 15.6231 1.31756 15.809C1.31756 15.9948 1.35425 16.1788 1.42551 16.3504C1.49677 16.5219 1.60122 16.6779 1.73285 16.8091C1.8382 16.8959 1.97048 16.9434 2.10701 16.9434C2.24354 16.9434 2.37581 16.8959 2.48117 16.8091L8.97021 10.3165L14.8357 16.1819C14.9668 16.3136 15.1227 16.4179 15.2943 16.4892C15.466 16.5605 15.65 16.5971 15.8358 16.5971C16.0217 16.5971 16.2057 16.5605 16.3772 16.4892C16.5488 16.4179 16.7047 16.3136 16.8359 16.1819C16.9227 16.0765 16.9702 15.9442 16.9702 15.8077C16.9702 15.6712 16.9227 15.5389 16.8359 15.4336L10.3433 8.94336L16.2076 3.07792Z"
        fill="#1E1932"
      />
    </svg>
  )
}

export default CloseIcon
